import { render, staticRenderFns } from "./SubsidyListForm.vue?vue&type=template&id=ef87786c&"
import script from "./SubsidyListForm.vue?vue&type=script&lang=js&"
export * from "./SubsidyListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports